document.addEventListener('DOMContentLoaded', () => {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    const dropdowns = document.querySelectorAll('.dropdown');
    const overlay = document.querySelector('.modal-overlay');

    function fadeIn(element, duration = 200) {
        if (!element) return;
        element.style.opacity = 0;
        element.style.display = 'block';
        element.style.transition = `opacity ${duration}ms`;
        requestAnimationFrame(() => {
            element.style.opacity = 1;
        });
    }

    function fadeOut(element, duration = 200) {
        if (!element) return;
        element.style.opacity = 1;
        element.style.transition = `opacity ${duration}ms`;
        element.style.opacity = 0;
        setTimeout(() => {
            element.style.display = 'none';
        }, duration);
    }

    // Translations and extra navigation links can outgrow a desktop header.
    // Measure the actual row before using the existing compact menu, so no
    // language depends on a guessed viewport breakpoint.
    const responsiveHeader = document.querySelector('[data-responsive-nav]');
    if (responsiveHeader) {
        const container = responsiveHeader.querySelector('.inner > .container');
        const menu = responsiveHeader.querySelector('.mb-menu');
        const nav = responsiveHeader.querySelector('#menu-cleaner-menu');
        const logo = responsiveHeader.querySelector('.main-logo');
        const controls = container?.querySelector(':scope > .mb-section');
        const burger = document.getElementById('burgerBtn');
        let scheduled = false;
        // Tried in order, each one narrower than the last; the burger is what
        // happens when even the last of them leaves the row overflowing.
        const fitSteps = ['nav-tight', 'nav-tighter', 'nav-nowordmark'];
        function rowFits() {
            const style = getComputedStyle(container);
            const available = container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
            const menuStyle = getComputedStyle(menu);
            // Two floors: the logo and the utilities share the first, the
            // product links have the second to themselves. Either one
            // overflowing is enough to walk the ladder.
            const first = logo.offsetWidth + controls.offsetWidth + (parseFloat(style.columnGap) || 0);
            const second = nav.scrollWidth + parseFloat(menuStyle.paddingLeft) + parseFloat(menuStyle.paddingRight);
            return Math.max(first, second) <= available;
        }
        function fitHeader() {
            scheduled = false;
            if (!container || !menu || !nav || !logo || !controls) return;
            responsiveHeader.classList.remove('nav-collapsed', ...fitSteps);
            if (window.innerWidth > 990) {
                /* The container stops growing at its max-width, so this asks the
                   row itself rather than the viewport: shrink a step, measure
                   again, and stop at the first size that fits. */
                for (let step = 0; step < fitSteps.length && !rowFits(); step++) {
                    responsiveHeader.classList.add(fitSteps[step]);
                }
                if (!rowFits()) {
                    // the panel has its own type scale; it must not inherit the
                    // squeezed one the failed attempts left behind
                    responsiveHeader.classList.remove(...fitSteps);
                    responsiveHeader.classList.add('nav-collapsed');
                }
            }
            if (responsiveHeader.classList.contains('mb-header')) {
                if (getComputedStyle(burger).display === 'none') {
                    menu.classList.remove('show');
                    burger.classList.remove('active');
                    burger.setAttribute('aria-expanded', 'false');
                    responsiveHeader.classList.remove('mb-header');
                    document.body.classList.remove('modal-open');
                    fadeOut(overlay);
                } else {
                    document.documentElement.style.setProperty('--mbmenu-top', responsiveHeader.offsetHeight + 'px');
                }
            }
        }
        function scheduleFit() {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(fitHeader);
        }
        window.addEventListener('resize', scheduleFit, {passive: true});
        document.fonts?.ready.then(scheduleFit);
        new MutationObserver(scheduleFit).observe(nav, {childList: true, characterData: true, subtree: true});
        fitHeader();
    }

    // Burger menu. It lives here rather than in data_q.js because every page with
    // the ds header loads this file, while data_q.js is only on the tool pages —
    // the detector, the history and the content pages had a dead burger button.
    // Open state is four things at once: .mb-menu.show, #burgerBtn.active,
    // body.modal-open and #header.mb-header; every close path clears all four.
    document.getElementById('burgerBtn')?.addEventListener('click', function () {
        const isActive = this.classList.contains('active');
        this.classList.toggle('active');
        this.setAttribute('aria-expanded', String(!isActive));

        // Pin the fixed panel right under the header. Its own height, not its
        // rect: the header is sticky at top:0, so while the menu is open its
        // bottom edge is exactly one header-height from the top of the viewport.
        // getBoundingClientRect().bottom was read before the page got locked and
        // before iOS finished moving the header, so the panel opened at a stale
        // offset — a strip of bare page content between the header and the menu.
        if (!isActive) {
            const header = document.getElementById('header');
            if (header) {
                document.documentElement.style.setProperty('--mbmenu-top', header.offsetHeight + 'px');
            }
        }

        document.querySelector('.mb-menu')?.classList.toggle('show');
        document.body.classList.toggle('modal-open');
        document.getElementById('header')?.classList.toggle('mb-header');

        if (isActive) {
            fadeOut(overlay);
        } else {
            setTimeout(() => fadeIn(overlay), 0);
        }
    });

    // An in-page link inside the panel (Subscribe -> #newsletter) leaves the menu
    // covering the target, so the item reads as dead. Close on any link: an
    // anchor reveals what it jumped to, and a real navigation unloads the page
    // anyway, so there is nothing to gain from telling the two apart.
    document.querySelector('.mb-menu')?.addEventListener('click', event => {
        if (!event.target.closest('a[href]')) return;

        document.querySelector('.mb-menu')?.classList.remove('show');
        document.getElementById('burgerBtn')?.classList.remove('active');
        document.body.classList.remove('modal-open');
        document.getElementById('header')?.classList.remove('mb-header');
        fadeOut(overlay);
    });

    // The toggles declare aria-expanded in the markup, so a screen reader is
    // told the state on every open and close, not only on the first render.
    function syncExpanded(dropdown) {
        const toggle = dropdown?.querySelector('.dropdown-toggle[aria-expanded]');
        if (toggle) toggle.setAttribute('aria-expanded', String(dropdown.classList.contains('open')));
    }

    dropdownToggles.forEach(dropdownToggle => {
        if (!dropdownToggle) return;

        dropdownToggle.addEventListener('click', event => {
            event.preventDefault();
            const element = event.currentTarget;
            const dropdown = element.closest('.dropdown');
            const screenWidth = window.innerWidth;

            if (element.classList.contains('dropdown-item')) {
                dropdown.classList.toggle('open');
                syncExpanded(dropdown);
                return;
            }

            if (dropdown.classList.contains('open')) {
                dropdown.classList.remove('open');
                syncExpanded(dropdown);

                if (dropdown.classList.contains('dash-h-item') && screenWidth < 768) {
                    const menu = document.querySelector('.user-menu');
                    if (menu) menu.classList.remove('show');
                    document.body.classList.remove('modal-open');
                    document.getElementById('header')?.classList.remove('mb-header');
                    if (overlay) fadeOut(overlay);
                }
            } else {
                dropdowns.forEach(d => {
                    d.classList.remove('open');
                    syncExpanded(d);
                });
                dropdown.classList.add('open');
                syncExpanded(dropdown);

                if (dropdown.classList.contains('dash-h-item') && screenWidth < 768) {
                    document.body.classList.add('modal-open');
                    // the overlay (z-index 54) sits above the header, so the menu
                    // would open underneath it and swallow every click
                    document.getElementById('header')?.classList.add('mb-header');
                    if (overlay) fadeIn(overlay);
                }
            }
        });
    });

    // The nav's Tools popover follows keyboard conventions: Esc closes it and
    // hands focus back to its toggle, and tabbing past its last item closes it
    // behind you. Scoped to .tools-item — the avatar and admin menus keep the
    // behaviour they have always had.
    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.tools-item.dropdown.open').forEach(dropdown => {
            const hadFocus = dropdown.contains(document.activeElement);
            dropdown.classList.remove('open');
            syncExpanded(dropdown);
            if (hadFocus) dropdown.querySelector('.dropdown-toggle')?.focus();
        });
    });
    document.querySelectorAll('.tools-item.dropdown').forEach(dropdown => {
        dropdown.addEventListener('focusout', () => {
            // setTimeout, not rAF: focusout fires before the next element gets
            // focus, and rAF stalls entirely in background tabs
            setTimeout(() => {
                if (!dropdown.contains(document.activeElement) && dropdown.classList.contains('open')) {
                    dropdown.classList.remove('open');
                    syncExpanded(dropdown);
                }
            }, 0);
        });
    });

    const modalOverlays = document.querySelectorAll('.modal-overlay');
    modalOverlays?.forEach(modal => {
        modal.addEventListener('click', () => {
            modal.style.transition = 'opacity 0.2s';
            modal.style.opacity = '0';
            setTimeout(() => {
                modal.style.display = 'none';
            }, 200);
            document.body.classList.remove('modal-open');
            // keep the header state in sync: the burger click toggles this class,
            // so leaving it set here would invert it on the next open and put
            // the menu below the overlay (the user menu raises it as well)
            document.getElementById('header')?.classList.remove('mb-header');
            const navMenu = document.querySelector('.mb-menu');
            if (navMenu && navMenu.classList.contains('show')) {
                navMenu.classList.remove('show');
                document.getElementById('burgerBtn')?.classList.remove('active');
            }
        });
    });

    window.addEventListener('click', (event) => {
        const buttonDropdown = event.target;
        const dropdownChild = buttonDropdown.closest('.dropdown-toggle') ?? false;
        const overlay = document.querySelector('.modal-overlay');

        const isUserMenu = event.target.classList.contains('user-menu');
        const isUserDataParent = event.target.parentNode?.classList.contains('user-data');
        const isUserMenuParent = event.target.parentNode?.classList.contains('user-menu');
        const isInput = event.target.tagName === 'INPUT';

        if (
            !buttonDropdown.classList.contains('dropdown-toggle') &&
            dropdownChild === false &&
            !isUserMenu &&
            !isUserDataParent &&
            !isUserMenuParent &&
            !isInput
        ) {
            const dropdowns = document.querySelectorAll('.dropdown');
            dropdowns.forEach(dropdown => {
                if (dropdown && dropdown.classList.contains('open')) {
                    dropdown.classList.remove('open');
                    syncExpanded(dropdown);
                    fadeOut(overlay);
                    if (!document.querySelector('.mb-menu.show')) {
                        document.getElementById('header')?.classList.remove('mb-header');
                    }
                }
            });
        }
    });

    // FAQ

    const faqItems = document.querySelectorAll('.item h3');
    const aModals = document.querySelectorAll('.modal');

    window.addEventListener("resize", () => {

        let anyModalOpen = false;
        const screenWidth = window.innerWidth;
        const menuAuth = document.querySelector('.dash-h-item');
        const menuNoAuth = document.querySelector('.mb-menu');
        

        aModals.forEach(modal => {
            if (modal.classList.contains('modal-open')) {
                anyModalOpen = true;
            }
        });

        if (!anyModalOpen) {
            if(screenWidth > 767) {
                document.body.classList.remove('modal-open');
            } else {
                if((menuAuth && menuAuth.classList.contains('open')) || 
                    (menuNoAuth && menuNoAuth.classList.contains('show'))
                ) {
                    document.body.classList.add('modal-open');
                }
            }
        }

        faqItems.forEach(el => {

            if(el.parentElement.classList.contains('active')) {
                const child = el.parentElement.querySelector('.collapse');
                // The height left over from the last toggle is stale once the
                // answer rewraps, and measuring .cinner instead of the panel
                // drops its bottom padding — the divider ends up glued to the
                // text. Drop the inline height and let the CSS keep it auto
                // (.collapse.show:not([style])); the next toggle re-measures.
                child.removeAttribute('style');
                child.offsetHeight;
            }
        })

    });

    faqItems.forEach(el => (
        el.addEventListener('click', function(e) {

            const parent = e.target.parentElement;

            // Items toggle independently (no accordion): they are open by
            // default in the new design, so closing the rest would collapse
            // the whole FAQ on a single click.
            parent.classList.toggle('active');
            const element = parent.querySelector('.collapse');

            if (element.classList.contains('show')) {
                element.style.height = element.scrollHeight + 'px';
                element.offsetHeight;
                element.style.height = '0';
                element.classList.remove('show');
            } else {
                element.classList.add('show');
                element.style.height = '0';
                element.offsetHeight;
                element.style.height = element.scrollHeight + 'px';
                // once the panel is open, hand the height back to the CSS: a
                // pixel value frozen at click time clips the answer as soon as
                // it rewraps. A timeout, not transitionend — the transition is
                // skipped entirely under prefers-reduced-motion.
                window.setTimeout(() => {
                    if (element.classList.contains('show')) element.removeAttribute('style');
                }, 450);
            }
        })
    ));

    // MODAL

    document.addEventListener('click', function(e) {
        if (e.target && e.target.classList.contains('dwnlbtn')) {
            if (window.innerWidth > 767) {
                e.preventDefault();

                const target = document.querySelector(e.target.getAttribute('data-target'));
                if (target) {
                    target.classList.add('modal-open');
                    document.body.classList.add('modal-open');
                }
            }
        }
    });

    const modals = document.querySelectorAll('.modal');

    modals.forEach(modal => {
        modal?.addEventListener('click', function(e) {
            // Consent is the only way past the Terms prompt. Its two explicit
            // actions remain live, but neither a backdrop click nor the generic
            // "any button closes" rule may dismiss the dialog.
            if (e.currentTarget.hasAttribute('data-static-modal')) return;

            /* The What's new overlay closes itself (whats-new.js: cross,
               "Maybe later", backdrop, Esc). Its stepper arrows and dots are
               buttons, which the generic rule below would read as "close". */
            if (e.currentTarget.id === 'wnOverlay') return;

            /* The same for a dialog that carries a form (the unsupported-
               language one: unsupported-language-modal.js): Subscribe is a
               button too, and a click on an icon sits deep enough in
               .modal-body for the rule below to read it as the backdrop. */
            if (e.currentTarget.hasAttribute('data-closes-itself')) return;

            e.stopPropagation();

            if (e.currentTarget && e.currentTarget.classList.contains('modal') &&
                !e.target.classList.contains('modal-body') && !e.target.parentElement.classList.contains('modal-body') &&
                !e.target.parentElement.parentElement.classList.contains('modal-body') ||
                e.target.tagName === 'BUTTON'
            ) {
                e.currentTarget.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }
        });
    })

    /* A closed modal is display:none, which is enough for the eye but says
       nothing to a screen reader walking the tree — a fresh page offered it
       half a dozen dialogs that were not open. hidden and aria-hidden say it
       properly. They are kept in step with .modal-open from here rather than at
       the call sites: the class is added and removed in five different files
       (data_q.js, ai-detector.js, account-history.js, iframe-script.js and this
       one), and one forgotten caller would leave an open dialog marked hidden.
       The class still owns what is on screen — .modal.modal-open sets display,
       which outranks the hidden attribute — so a missed sync can never leave a
       dialog invisible. */
    const syncModalHidden = function (modal) {
        const isOpen = modal.classList.contains('modal-open');
        modal.toggleAttribute('hidden', !isOpen);
        modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    };

    modals.forEach(modal => {
        syncModalHidden(modal);
        new MutationObserver(() => syncModalHidden(modal))
            .observe(modal, { attributes: true, attributeFilter: ['class'] });
    });

    // Scrollbar

    const addScrollWhenMobileWidthOnDesktop = function() {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
        const elements = document.querySelectorAll('.scrollbar-none');

        elements.forEach(function(element) {
            if (!isMobile) {
                element.classList.add('activeScrollbar');
            } else {
                if (element.classList.contains('activeScrollBar')) {
                    element.classList.remove('activeScrollBar');
                }
            }
        });
    };

    window.addEventListener('resize', addScrollWhenMobileWidthOnDesktop);
    addScrollWhenMobileWidthOnDesktop();

    function openFAQ(id) {
        const faq = document.querySelector(id);
        if (!faq) return;
        faqItems.forEach(el => {
            el.parentElement.classList.remove('active');
            const child = el.parentElement.querySelector('.collapse');
            child.style.height = child.scrollHeight + 'px';
            child.offsetHeight;
            child.style.height = '0';
            child.classList.remove('show');
        })

        const trigger = faq.querySelector('h3');
        if (trigger) {
            trigger.click();
        }

        setTimeout(() => {
            faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 250);
    }

    const uninstallLink = document.querySelector('.faq-uninstall');
    uninstallLink?.addEventListener('click', function(e) {
        e.preventDefault()
        openFAQ(this.getAttribute('href'))
    })

    const dashboardBtn = document.getElementById('headerdrp-collapse');
    const dashboardSidebar = document.querySelector('.dash-sidebar');

    dashboardBtn?.addEventListener('click', function(e) {
        e.preventDefault();
        if(dashboardSidebar.classList.contains('open')) {
            dashboardSidebar.classList.remove('open')
        } else {
            dashboardSidebar.classList.add('open')
        }

    })

// === COOKIES UTILS ===
    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + (days*24*60*60*1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

// === INPUT FIELD RESIZE ===
    /* The field can be dragged taller, and the drag writes an inline height on it.
       That height outranks the rules that size the panel, so once the field is
       empty again — "Remove text", or the last character deleted — it has to go,
       or the panel keeps the dragged height with nothing in it. */
    const resizableFields = document.querySelectorAll('.original-block .quill-editor-container, #detectorForm textarea');

    function fieldText(field) {
        if (field.tagName === 'TEXTAREA') return field.value;
        return field.querySelector('.ql-editor')?.innerText || '';
    }

    function dropHeightWhenEmpty() {
        resizableFields.forEach(field => {
            if (!fieldText(field).trim()) field.style.removeProperty('height');
        });
    }

    resizableFields.forEach(field => {
        field.addEventListener('input', dropHeightWhenEmpty);
        new MutationObserver(dropHeightWhenEmpty).observe(field, {
            childList: true, subtree: true, characterData: true
        });
    });

    /* the clear buttons empty the field through their own code, so wait a tick */
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.remove-text, .btn-clear')) return;
        setTimeout(dropHeightWhenEmpty, 0);
    });

// === COOKIES BANNER ===
    setTimeout(function() {
        if (!getCookie('cookies-banner')) {
            document.querySelector('.cookies-banner')?.classList.add('show');
        }
    }, 5000);

    document.addEventListener('click', function(e) {
        if (e.target.closest('#cookies-banner .btn')) {
            document.querySelector('.cookies-banner')?.classList.remove('show');
            document.querySelector('.cookies-banner')?.classList.add('hidden');
            setCookie('cookies-banner', 'true', 365);
        }
    });


    /* === FEEDBACK BUBBLE ON A PHONE ===
       The bubble is fixed to the bottom right, which on a phone is where the
       Humanize / Paraphrase / Check button sits — it covered the thing the page
       exists for. It stays out of the way until the button has scrolled at
       least 50px past the top of the screen, and hides again on the way back.
       Pages without a submit button (legal, articles) keep it always on. */
    (function feedbackBubble() {
        var bubble = document.querySelector('.feedback');
        if (!bubble) return;

        var submit = document.querySelector(
            '.tool .quillFooter .greenBtn, .tool .quillFooter button[type="submit"], #detectorSubmit'
        );
        var PHONE = 720;
        var GRACE = 50;

        function apply() {
            if (window.innerWidth > PHONE || !submit) {
                bubble.classList.add('feed-visible');
                return;
            }
            var past = submit.getBoundingClientRect().bottom < -GRACE;
            bubble.classList.toggle('feed-visible', past);
            if (!past) bubble.classList.remove('show');   // a menu left open would float alone
        }

        apply();
        addEventListener('scroll', apply, { passive: true });
        addEventListener('resize', apply);
        addEventListener('orientationchange', apply);
    })();

});
